import { ProductReview } from "@lib/data/products"

import StarRating from "./star-rating"

// Fixed locale so the server-rendered first page and client-appended pages
// format identically (no hydration mismatch).
export const formatReviewDate = (value: string): string => {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) {
    return ""
  }
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  })
}

const ReviewCard = ({ review }: { review: ProductReview }) => {
  return (
    <div className="flex flex-col gap-y-2 border-b border-gray-200 py-6 last:border-b-0">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <StarRating rating={review.rating} />
        {review.title && (
          <span className="font-bold text-ui-fg-base">{review.title}</span>
        )}
      </div>
      {review.body && (
        <p className="whitespace-pre-wrap text-ui-fg-subtle">{review.body}</p>
      )}
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-ui-fg-muted">
        <span className="font-medium text-ui-fg-subtle">
          {review.reviewer_name}
        </span>
        {review.verified && (
          <span className="inline-flex items-center rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-700">
            Verified Purchase
          </span>
        )}
        <span>{formatReviewDate(review.created_at)}</span>
      </div>
    </div>
  )
}

export default ReviewCard
